
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiBrands } from "@/core/api";
import mixin from "@/mixins";

export default defineComponent({
  name: "add-brand-modal",
  components: {},
  emits: ["update-list", "reset-form"],
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const addBrandModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const loading = ref<boolean>(false);
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();
    const formData = ref({
      status: 10,
      name: "",
      logo: "",
      short_key: "",
      description: "",
      seo_title: "",
      seo_description: "",
      website: "",
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "Brand Name is required",
          trigger: "change",
        },
      ],
      short_key: [
        {
          required: true,
          message: "Brand Short-Key is required",
          trigger: "change",
        },
      ],
      description: [
        {
          required: true,
          message: "Description is required",
          trigger: "change",
        },
      ],
      seo_title: [
        {
          required: true,
          message: "Seo title is required",
          trigger: "change",
        },
      ],
      seo_description: [
        {
          required: true,
          message: "Seo description is required",
          trigger: "change",
        },
      ],
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiBrands.addBrands(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addBrandModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const handleDiscard = () => {
      hideModal(addBrandModalRef.value);
      resetForm();
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    return {
      loading,
      formData,
      rules,
      formRef,
      addBrandModalRef,
      submitButton,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
